import React from 'react';

import { useBreakpoints } from '@/hooks';

import { useHeaderContext } from '../../context';

import * as S from './title.styles';

type JobTitleProps = {
  children: React.ReactNode;
};

const JobTitle: React.FC<JobTitleProps> = ({ children }) => {
  const { isMobile } = useBreakpoints();

  return isMobile ? (
    <S.StyledHeadline size="xxlarge" forwardedAs="h1" data-testid="job-title">
      {children}
    </S.StyledHeadline>
  ) : (
    <S.StyledHero size="small" forwardedAs="h1" data-testid="job-title">
      {children}
    </S.StyledHero>
  );
};

export const Title: React.FC = () => {
  const { title } = useHeaderContext();

  return (
    <S.TitleContainer>
      <JobTitle>{title}</JobTitle>
    </S.TitleContainer>
  );
};
